"use client";
import React from "react";
import Image from "next/image";
import IMAGES from "@/data/assetData";

const TYPES = [
  { key: "bike", label: "Bikes", icon: IMAGES.activeMoterBike, alt: "Bike" },
  { key: "car", label: "Cars", icon: IMAGES.activeCar, alt: "Car" },
];

/**
 * Single source of truth for the Bikes/Cars selector so it looks identical
 * everywhere in the funnel (hero pill + mobile search overlay). Shape, size,
 * icon treatment, the checkmark badge, and the selected accent are shared; only
 * the UNSELECTED background adapts to the surface it sits on:
 *   variant="onDark"  → glass chips over the dark hero image
 *   variant="onLight" → solid chips on a white modal/surface
 */
const VehicleTypeToggle = ({ selectedItems = [], toggleSelection, variant = "onLight", className = "" }) => {
  const onDark = variant === "onDark";
  return (
    <div className={`flex ${className}`}>
      {TYPES.map(({ key, label, icon, alt }) => {
        const selected = selectedItems.includes(key);
        return (
          <button
            key={key}
            type="button"
            aria-pressed={selected}
            onClick={() => toggleSelection(key)}
            className={`flex items-center justify-center py-[5px] pl-1.5 pr-3 gap-1 rounded-pill border cursor-pointer text-xs font-medium transition-[background,border-color,color] duration-150 ${
              selected
                ? "bg-redSurface-50 border-primary text-primary"
                : onDark
                  ? "bg-white/15 border-white/25 text-white backdrop-blur-lg hover:bg-white/25"
                  : "bg-bgPage border-gray-200 text-textPrimary hover:border-gray-300"
            }`}
          >
            <span className="relative flex items-center justify-center">
              <Image
                src={icon}
                alt={alt}
                width={20}
                height={20}
                className={`w-7 h-7 object-contain ${!selected && onDark ? "invert" : ""}`}
              />
              {selected && (
                <span className="absolute -top-[3px] -right-1.5 w-3.5 h-3.5 rounded-full bg-primary border-[1.5px] border-white flex items-center justify-center">
                  <svg width="9" height="9" viewBox="0 0 24 24" fill="none" className="w-[7px] h-[7px]">
                    <path d="M20 6L9 17l-5-5" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
              )}
            </span>
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default VehicleTypeToggle;
